import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../components/templates/Layout'
import CustomTable from '../../components/molecules/CustomTable'
import CustomSearch from '../../components/molecules/CustomSearch'
import { useFormik } from 'formik'
import AlertContext from '../../context/alert/alertContext'
import CommunicationContext from '../../context/communication/communicationContext'
import TemplateManage from './TemplateManage'
import { useTranslation } from 'react-i18next'

const AllTemplate = (props) => {
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const { t } = useTranslation()
    const { setAlert } = alertContext
    const {
        all_templates,
        getAllSearchTemplates,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        action: '',
    })

    let action = props.action ? props.action : props.match?.params?.action

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id, action: action })
        } else {
            setManage({ popup, status: 'new', id: 0, action: action })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            emailsearch: '',
            phonesearch: '',
            filters: true,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllSearchTemplates(values)
        },
    })

    useEffect(() => {
        if (all_templates) {
            setTableBody(
                all_templates.records.length ? all_templates.records : []
            )
        }
        setIsLoading(false)
    }, [all_templates])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.searchterm = ''
        formik.values.emailsearch = ''
        formik.values.phonesearch = ''
        getAllSearchTemplates(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from === 'Communicationtemplates' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.action = action
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllSearchTemplates(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const resetForm = () => {
        formik.values.page = 1
        formik.values.searchterm = ''
        formik.values.emailsearch = ''
        formik.values.phonesearch = ''
        getAllSearchTemplates(formik.values)
    }

    const tableValues = [
        {
            field: 'subject',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Subject'),
            width: 500,
            filterable: true,
            filterField: 'subject',
        },
    ]

    if (action === 'emailLogs') {
        tableValues.push({
            field: 'email',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Email'),
            filterable: true,
            filterField: 'u.email',
        })
    } else {
        tableValues.push({
            field: 'phone',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Phone number'),
            width: 200,
            filterable: true,
            filterField: 'u.phone',
        })
    }
    tableValues.push({
        field: 'date_sent',
        type: 'date',
        firstChild: true,
        sort: true,
        disablePadding: false,
        label: t('Date sent'),
        filterable: true,
        filterField: 'lg.date_sent',
        width: 200,
    })

    const searchInfo = [
        {
            label: t('Subject'),
            placeholder: t('Enter Subject'),
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    if (action === 'emailLogs') {
        searchInfo.push({
            label: t('Email'),
            placeholder: t('Enter Email'),
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'emailsearch',
            formik: formik,
        })
    } else {
        searchInfo.push({
            label: t('Phone'),
            placeholder: t('Enter Phone Number'),
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'phonesearch',
            formik: formik,
        })
    }

    return (
        <>
            {props.layout ? (
                <>
                    {' '}
                    <div className="dashboard communications">
                        <CustomSearch
                            searchInfo={searchInfo}
                            formik={formik}
                            advFilters={props.advFilters}
                            resetForm={resetForm}
                        />
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={all_templates}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllSearchTemplates}
                            hideCompactView={props.hideCompactView}
                        />
                    </div>
                    <TemplateManage
                        data={manage}
                        function={toggleFullScreenPopup}
                    />
                </>
            ) : (
                <Layout
                    noUI={props.noUI || false}
                    renderSidePanelDefault={
                        props.renderSidePanelDefault || false
                    }
                >
                    {' '}
                    <div className="dashboard communications">
                        <CustomSearch
                            searchInfo={searchInfo}
                            formik={formik}
                            advFilters={props.advFilters}
                            resetForm={resetForm}
                        />
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={all_templates}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllSearchTemplates}
                            hideCompactView={props.hideCompactView}
                        />
                    </div>
                    <TemplateManage
                        data={manage}
                        function={toggleFullScreenPopup}
                    />
                </Layout>
            )}
        </>
    )
}
export default AllTemplate
